import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { SellerGuard } from "./guards/seller-guard.guard";
import { OnboardingSequenceGuard } from "./guards/onboarding-sequence.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "folder",
    redirectTo: "folder/Inbox",
    pathMatch: "full",
  },
  {
    path: "home",
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "seller/:id",
    loadChildren: () =>
      import("./pages/seller/seller.module").then((m) => m.SellerPageModule),
  },
  {
    path: "product/:idSeller/:idProduct",
    loadChildren: () =>
      import("./pages/product/product.module").then((m) => m.ProductPageModule),
  },
  {
    path: "service/:idSeller/:idService",
    loadChildren: () =>
      import("./pages/service/service.module").then((m) => m.ServicePageModule),
  },
  /* {
    path: "email",
    loadChildren: () =>
      import("./pages/register/email/email.module").then(
        (m) => m.EmailPageModule
      ),
  },
  {
    path: "phone",
    loadChildren: () =>
      import("./pages/register/phone/phone.module").then(
        (m) => m.PhonePageModule
      ),
  },
  {
    path: "password",
    loadChildren: () =>
      import("./pages/register/password/password.module").then(
        (m) => m.PasswordPageModule
      ),
  },
  {
    path: "address",
    loadChildren: () =>
      import("./pages/register/address/address.module").then(
        (m) => m.AddressPageModule
      ),
  }, */
  {
    path: "no-logged",
    loadChildren: () =>
      import("./pages/no-logged/no-logged.module").then(
        (m) => m.NoLoggedPageModule
      ),
  },
  {
    path: "tip",
    loadChildren: () =>
      import("./pages/tip/tip.module").then((m) => m.TipPageModule),
  },
  {
    path: "article/:id",
    loadChildren: () =>
      import("./pages/article/article.module").then((m) => m.ArticlePageModule),
  },
  {
    path: "checkout",
    loadChildren: () =>
      import("./pages/checkout/checkout.module").then(
        (m) => m.CheckoutPageModule
      ),
  },
  {
    path: "orders",
    loadChildren: () =>
      import("./pages/orders/orders.module").then((m) => m.OrdersPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "order/:id",
    loadChildren: () =>
      import("./pages/order/order.module").then((m) => m.OrderPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./pages/profile/profile.module").then((m) => m.ProfilePageModule),
  },
  {
    path: "payment-method",
    loadChildren: () =>
      import("./pages/payment-method/payment-method.module").then(
        (m) => m.PaymentMethodPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "logged-seller",
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("./pages/logged-seller/home/home.module").then(
            (m) => m.HomePageModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "store",
        loadChildren: () =>
          import("./pages/logged-seller/store/store.module").then(
            (m) => m.StorePageModule
          ),
        canActivate: [AuthGuard, OnboardingSequenceGuard],
      },
      {
        path: ":idSeller/products",
        loadChildren: () =>
          import("./pages/logged-seller/products/products.module").then(
            (m) => m.ProductsPageModule
          ),
        canActivate: [AuthGuard, SellerGuard],
      },
      {
        path: ':idSeller/services',
        loadChildren: () =>
          import('./pages/logged-seller/services/services.module').then(
            (m) => m.ServicesPageModule
          ),
        canActivate: [AuthGuard, SellerGuard],
      },
      {
        path: 'orders',
        loadChildren: () => import('./pages/logged-seller/orders/orders.module').then( m => m.OrdersPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'order/:id',
        loadChildren: () => import('./pages/logged-seller/order/order.module').then( m => m.OrderPageModule)
      },
    ],
  },
  {
    path: "terms",
    loadChildren: () =>
      import("./pages/terms/terms.module").then((m) => m.TermsPageModule),
  },
  {
    path: 'seller-select',
    loadChildren: () => import('./pages/register/seller-select/seller-select.module').then( m => m.SellerSelectPageModule),
    canActivate: [OnboardingSequenceGuard]
  },
  {
    path: 'confirm-contract',
    loadChildren: () => import('./pages/confirm-contract/confirm-contract.module').then( m => m.ConfirmContractPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'plans',
    loadChildren: () => import('./pages/logged-seller/contracts/plan.module').then( m => m.PlanPageModule),
    canActivate: [AuthGuard, OnboardingSequenceGuard]
  },
  {
    path: 'kyc-link',
    loadChildren: () => import('./pages/kyc-link/kyc-link.module').then( m => m.KycLinkPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'document-viewer/:docName',
    loadChildren: () => import('./pages/document-viewer/document-viewer.module').then(m => m.DocumentViewerPageModule)
  },
  {
    path: 'pending-documents',
    loadChildren: () => import('./pages/logged-seller/pending-documents/pending-documents.module').then( m => m.PendingDocumentsPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}